import type { HttpCancelTokens } from 'http'

import type { SetCancelTokenPayload } from 'store'

export const useCancelTokensStore = defineStore('cancelTokens.store', () => {
  const cancelTokens = ref<HttpCancelTokens>({})

  const setCancelToken = ({ cancelTokenId, token }: SetCancelTokenPayload) => {
    if (process.server) return

    cancelTokens.value[cancelTokenId] = token
  }

  const deleteCancelToken = (cancelTokenId: string) => {
    delete cancelTokens.value[cancelTokenId]
  }

  return {
    cancelTokens,
    setCancelToken,
    deleteCancelToken,
  }
})
